export const NEW_CHAT_SESSION_ID = 'new';
